import React from "react";

import UserIcon from "core/gd-ui/icon/user/user";
import Select from "core/gd-ui/select/text";

export default function ModalAddUserProjectUsersMeeingRow(props) {

    const onUserClick = (userId, e) => {props.onUserClick(props.user.id, e)};
    const onRoleSelect = (role) => {props.onRoleSelect(props.user.id, role)};

    const options = [
        {label: 'Participant',  value: gd.const.meeting.role.PARTICIPANT},
        {label: 'Organizer',    value: gd.const.meeting.role.ORGANIZER}
    ];

    const selectedItem = _.find(props.selected, (o)=>o.userId === props.user.id);

    const checkboxClasses = Classes('ui5-cb', 's-16', {
        selected: !!selectedItem
    });

    const classes = Classes('row',{
        selected: !!selectedItem
    });

    return (
        <div className={classes} onClick={onUserClick}>
            <div className="cell center">
                <div className={checkboxClasses}/>
            </div>
            <div className="cell content">
                <UserIcon userId={props.user.id} size="26" className="m-r-10" />
                <div className="user-name">{props.user.name}</div>
            </div>
            <div className="cell">
                {!!selectedItem &&
                <div className="role-block">
                    <Select options={options}
                            renderValue="text-13"
                            value={selectedItem.role}
                            onChange={onRoleSelect}
                            underlined="always"/>
                </div>}
            </div>
        </div>
    )
}